export const MEETING_TYPE_ENUM = {
  BADGES: "badges",
  AUDIT_FINDINGS: "audit_findings",
};

export const MEETING_REQUEST_CONFIG_NAME_MAP = {
  [MEETING_TYPE_ENUM.BADGES]: "slackMeetingRequestBadgesOptions",
  [MEETING_TYPE_ENUM.AUDIT_FINDINGS]: "slackMeetingRequestOptions",
};
